import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints } from '@vzrf/react-theme-helpers';

const FilterScrollContainerStyled = styled.div`
  display: flex;
  flex-grow: 2;
  position: relative;
  height: ${props => calculateRem(props.filterStyles.height)};
  overflow-x: hidden;
  overflow-y: hidden; /* Fix IE11 bug with showing scrolls */
  align-items: center;
  @media screen and (min-width: ${breakpoints.sm}) {
    width: ${({ showLeftScroll, showRightScroll }) =>
      `calc(100% - ${(showLeftScroll + showRightScroll) * 35}px)`};
  }
`;

class FilterChipContainerWrapper extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    closeChipLabel: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
      PropTypes.element,
    ]),
    filterChipStyles: PropTypes.object,
    filterStyles: PropTypes.object,
    getWrapperComponent: PropTypes.func.isRequired,
    showLeftScroll: PropTypes.bool,
    showRightScroll: PropTypes.bool,
  };

  static defaultProps = {
    closeChipLabel: undefined,
    filterChipStyles: undefined,
    filterStyles: undefined,
    showLeftScroll: false,
    showRightScroll: false,
  };

  getWrapperComponent = element => {
    if (!element) {
      return null;
    }

    this.element = element;
    this.props.getWrapperComponent(element);

    return element;
  };

  render() {
    return (
      <FilterScrollContainerStyled
        closeChipLabel={this.props.closeChipLabel}
        filterChipStyles={this.props.filterChipStyles}
        filterStyles={this.props.filterStyles}
        showLeftScroll={this.props.showLeftScroll}
        showRightScroll={this.props.showRightScroll}
        ref={this.getWrapperComponent}
      >
        {this.props.children}
      </FilterScrollContainerStyled>
    );
  }
}

export default FilterChipContainerWrapper;
